import { createApi } from '@reduxjs/toolkit/query/react';
import { newBackendAxiosBaseQuery } from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';
import { SearchResponse } from './searchApiTypes';

/**
 * The global search (⌘K / Ctrl+K, #3016): `GET /admin/search?q=`. The base
 * query already carries `/admin`, so the path is `/search`.
 *
 * Read-only, so no tags: a result list is a moment's answer, and the
 * palette refetches on every new query anyway. `keepUnusedDataFor` is short
 * so a closed palette does not serve a stale answer next time.
 */
export const searchApiSlice = createApi({
    reducerPath: 'searchApi',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: newBackendAxiosBaseQuery(),
    keepUnusedDataFor: 30,
    endpoints: (builder) => ({
        globalSearch: builder.query<SearchResponse, { q: string }>({
            query: ({ q }) => ({
                url: '/search',
                method: 'GET',
                params: { q },
            }),
        }),
    }),
});

export const { useGlobalSearchQuery } = searchApiSlice;
